export class GeoService {
    public static reset() {
        this.bigCircle = null;
        this.points = [];
        this.points2 = [];
        this.lastCircle = null;
        this.radius = 1.5;
    }
    public static getDistanceFromLatLng = function (lat1, lon1, lat2, lon2) {
        if (!lat1 || !lon1 || !lat2 || !lon2) {
            return 0;
        }

        let R = 6371; // Radius of the earth in km
        let dLat = this.deg2rad(lat2 - lat1);  // deg2rad below
        let dLon = this.deg2rad(lon2 - lon1);
        let a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2)
        ;
        let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        let d = R * c; // Distance in km
        return d * 1000;
    };

    public static deg2rad(deg) {
        return deg * (Math.PI / 180);
    }

    public static getPoints(lat, lng, bigRadius) {
        let centerPoint = new google.maps.LatLng(lat, lng);
        GeoService.bigCircle = new google.maps.Circle({
            center: {lat, lng},
            radius: bigRadius * 1000,
        });

        GeoService.createPoints(centerPoint, [0, 90, 180, -90], true);
        return GeoService.points2;
    }

    private static bigCircle;
    private static points = [];
    private static points2 = [];
    private static lastCircle = null;
    private static radius = 1.5;

    private static createPoints(centerPoint, a: (number | number)[], odd: boolean) {
        odd = !odd;
        if (!GeoService.lastCircle) {
            GeoService.lastCircle = new google.maps.Circle({
                center: centerPoint,
                radius: GeoService.radius * 1000,       // Convert to meters
            });
            GeoService.points.push({lat: centerPoint.lat().toFixed(2), lng: centerPoint.lng().toFixed(2)});
            GeoService.points2.push({lat: centerPoint.lat(), lng: centerPoint.lng()});
        }
        a.forEach(function (e) {
            let newPoint = GeoService.destinationPoint(centerPoint, e, GeoService.radius );

            if (GeoService.InCircle(GeoService.bigCircle, newPoint)) {
                if (!GeoService.points.any(p =>
                    parseFloat( p.lat).toFixed(2) == newPoint.lat().toFixed(2)
                    && parseFloat( p.lng).toFixed(2) == newPoint.lng().toFixed(2))) {
                    if (odd) {
                        GeoService.points.push({lat: newPoint.lat().toFixed(2), lng: newPoint.lng().toFixed(2)});
                        GeoService.points2.push({lat: newPoint.lat(), lng: newPoint.lng()});
                    }
                    GeoService.createPoints(newPoint, a, odd);
                }
            }
        });
    }

    private static InCircle(circle, point) {
        let bounds = circle.getBounds();
        if (bounds != null) {
            let center = circle.getCenter();
            let r = circle.getRadius();
            if (bounds.contains(point) && google.maps.geometry.spherical.computeDistanceBetween(point, center) < r) {
                return true;
            }
        }
    }

    public static destinationPoint(point, brng, dist) {
        dist = dist / 6371;
        brng = GeoService.toRad(brng);
        let lat1 = GeoService.toRad(point.lat());
        let lon1 = GeoService.toRad(point.lng());
        let lat2 = Math.asin(Math.sin(lat1) * Math.cos(dist) +
            Math.cos(lat1) * Math.sin(dist) * Math.cos(brng));

        let lon2 = lon1 + Math.atan2(Math.sin(brng) * Math.sin(dist) *
            Math.cos(lat1),
            Math.cos(dist) - Math.sin(lat1) *
            Math.sin(lat2));

        if (isNaN(lat2) || isNaN(lon2)) {
            return null;
        }

        return new google.maps.LatLng(GeoService.toDeg(lat2), GeoService.toDeg(lon2));
    }

    private static toRad(brng) {
        brng = parseFloat(brng);
        return brng * Math.PI / 180;
    }

    private static toDeg(brng) {
        brng = parseFloat(brng);
        return brng * 180 / Math.PI;
    };
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/services/geo.service.ts